import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { InfiniteScroll } from 'antd-mobile'
import { DotLoadingInBlock } from '../../../components_renew/common/DotLoadingInBlock'
import { ProductSearchBar } from '../../../components_renew/Mall/ProductSearchBar'
import { Container, Header, Wrapper } from '../../../components_renew/Layout'
import { ProductListItem } from '../../../components_renew/Mall/ProductListItem'
import { requestProductListData, setProductDetailsData } from '../../../actions/mallAction'

@withRouter
@connect((state) => {
    let { loading, keyword, data } = state.mallProductList
    return {
      loading,
      keyword,
      ...data['search']
    }
  }
)
class ProductSearch extends React.PureComponent {

  componentDidMount () {
    // let { list, index } = this.props
    // if (!(list.length > 0)) {
    //   this.props.dispatch(requestProductListData({ index }))
    // }
  }

  render () {
    const { list, loading, keyword, isLastPage } = this.props
    return <Container>
      <Header/>
      <ProductSearchBar defaultValue={keyword} onSearch={this.onSubmit}/>
      <Wrapper flex>
        <div>
          {list.map((item, index) => {
            return <ProductListItem key={index}
                                    {...item}
                                    onClick={this.toProductDetails.bind(this, item)}
                                    onIconClick={this.addCart}
            />
          })}
        </div>
        {
          list.length > 0 ?
            <div>
              <InfiniteScroll hasMore={!isLastPage} loadMore={this.onEndReached}/>
            </div>
            : loading && <DotLoadingInBlock/>
        }
      </Wrapper>
    </Container>
  }

  onSubmit = keyword => {
    this.props.dispatch(requestProductListData({ pageIndex: 1, keyword, index: 'search' }))
  }

  onEndReached = () => {
    let { loading, isLastPage, pageIndex, keyword } = this.props
    console.log('onEndReached', loading, isLastPage)
    if (loading || isLastPage) return
    this.props.dispatch(requestProductListData({ pageIndex: pageIndex + 1, index: 'search', keyword }))
  }

  toProductDetails = (data) => {
    this.props.dispatch(setProductDetailsData(data))
    this.props.history.push(`${window.PATH.MALL_PRODUCT_DETAILS}/${data['id']}`)
  }

}

export { ProductSearch }
